import React, { useContext,useCallback } from 'react'
import { useSelector } from 'react-redux';
import ActorDetailForm from "../../../../../commonComponents/formComponents/actorDetailForm";
import {ActorItemContext} from './actorItemProvider'


export const Consignee=({invoiceId})=>{
  const {roleId,invoiceActorRoleId,...rest}=useSelector((state) => state.InvoicesReducer.invoice?.invoiceList[invoiceId]?.consignee)||{}
  const actorDetails=useContext(ActorItemContext)
  const {updateNextedActorFieldValue,saveItemActorDetails} = actorDetails
 
  const updateActorFieldValue=useCallback((actorType,payload)=>{
    updateNextedActorFieldValue(actorType,payload,invoiceId)
  },[invoiceId])

  
  const saveActorDetails = useCallback((params)=>{
    params.roleId = roleId
    params.invoiceActorRoleId = invoiceActorRoleId
    saveItemActorDetails(params,invoiceId)
  },[invoiceId,roleId,invoiceActorRoleId])


  const boxNumber = {name:"3/9", eoriNo:"3/10"}
    return(
        <ActorDetailForm
          actorType="consignee"
          boxNumber={boxNumber}
          declarant
          invoiceId={invoiceId}
          disabled={false}
          actorName="Consignee Name"
          dataSource={rest}
          updateActorFieldValue={updateActorFieldValue}
          saveActorDetails={saveActorDetails}
          {...actorDetails}
        />
    )
}